export const GET_ENGAGEMENTS_ATTACHMENTS_REQUEST = 'GET_ENGAGEMENTS_ATTACHMENTS_REQUEST';
export const GET_ENGAGEMENTS_ATTACHMENTS_SUCCESS = 'GET_ENGAGEMENTS_ATTACHMENTS_SUCCESS';
export const GET_ENGAGEMENTS_ATTACHMENTS_FAILURE = 'GET_ENGAGEMENTS_ATTACHMENTS_FAILURE';
export const GET_ENGAGEMENTS_ATTACHMENTS_CLEAR = 'GET_ENGAGEMENTS_ATTACHMENTS_CLEAR';
